import AbstractSymbolBehaviour from "slotworks/components/matrix/symbol/behaviours/abstract-symbol-behaviour";
import SymbolComponent from "slotworks/components/matrix/symbol/symbol-component";
import Layers from "slotworks/graphics/layers/layers";
import Contract from "slotworks/utils/contract";
import Timer from "slotworks/utils/timer";

export default class BlinkSymbolBehaviour extends AbstractSymbolBehaviour {

    private blinkCount: number;
    private blinkDuration: number;

    private timerId: number;

    private show: boolean;

    /**
     *
     * @param symbol {SymbolComponent}
     * @param [blinkDuration=500] {number}
     * @param [blinkCount=4] {number}
     */
    constructor(symbol: SymbolComponent, blinkDuration: number = 500, blinkCount: number = 2) {
        super(symbol);

        this.blinkDuration = blinkDuration;
        this.blinkCount = blinkCount;
    }

    public static() {
        super.static();

        this.symbol.setLayer(Layers.MatrixContent);

        Timer.clearInterval(this.timerId);

        this.symbol.setSymbolFade(true);
        this.show = true;
    }

    /**
     * Blinks the symbol 4 times with 500ms between (by default)
     */
    public win(): Contract<void> {
        return new Contract<void>((resolve) => {

            this.symbol.setLayer(Layers.SymbolAnimations);

            let blinks = this.blinkCount;

            this.timerId = Timer.setInterval(() => {
                this.show = !this.show;
                this.symbol.setSymbolFade(this.show);
                if (this.show) {
                    blinks--;
                }

                if (blinks <= 0) {
                    Timer.clearInterval(this.timerId);

                    resolve(null);
                }
            }, this.blinkDuration);
        });
    }
}



// WEBPACK FOOTER //
// ./~/ifdef-loader/ifdef-loader.js??ref--0-1!./~/slotworks/components/matrix/symbol/behaviours/blink-symbol-behaviour.ts